export const GET_FILTER_DATA_REQUEST = 'GET_FILTER_DATA_REQUEST'
export const GET_FILTER_DATA_SUCCESS = 'GET_FILTER_DATA_SUCCESS'
export const GET_FILTER_DATA_FAILURE = 'GET_FILTER_DATA_FAILURE'